module.exports = __webpack_public_path__ + "static/media/comment-alt-lines.52129f83.svg";